export const SET_CONTEXT = 'context/SET_CONTEXT';
export const SET_BREADCRUMBS = 'context/SET_BREADCRUMBS';
export const SET_TOOLBARS = 'context/SET_TOOLBARS';
